import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';
import { Focusable } from 'react-aria-components';
import { Button, Heading } from 'ui';
import { formatMonth } from 'utils/DateFormats';
import { BookButton } from '~/components/BookButton';
import { Image } from '~/components/Image/Image';
import { ContactUsButton } from '~/components/Journey/ContactUsButton';
import { PricePerPerson } from '~/components/Journey/PricePerPerson';
import { Tooltip, TooltipTrigger } from '~/components/Tooltip';
import useJourneyData from '~/hooks/useJourneyData';
const bold = (chunks: ReactNode) => <strong>{chunks}</strong>;
const priceTag = () => <strong>
    <PricePerPerson />
  </strong>;
export default function JourneyBookingCTA() {
  const $ = _c(28);
  const {
    details,
    actions,
    region,
    items,
    isStartDateInPast
  } = useJourneyData();
  const t = useTranslations("journey");
  const firstItem = items[0];
  const closest_city = firstItem?.type === "Journey" ? firstItem.origin : undefined;
  const regionArticle = region.article ? `${region.article} ` : "";
  let t0;
  if ($[0] !== t) {
    t0 = t("booking_cta_image_alt");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <div className="absolute inset-0"><Image alt={t0} src="https://images.squarespace-cdn.com/content/v1/5f57799e5c71b34be1747d88/1600083892769-W2CTSPA65HYZFS793J0U/ke17ZwdGBToddI8pDm48kHH9S2ID7_bpupQnTdrPcoF7gQa3H78H3Y0txjaiv_0fDoOvxcdMmMKkDsyUqMSsMWxHk725yiiHCCLfrh8O1z4YTzHvnKhyp6Da-NYroOW3ZGjoBKy3azqku80C789l0nQwvinDXPV4EYh2MRzm-RRB5rUELEv7EY2n0AZOrEupxpSyqbqKSgmzcCPWV5WMiQ/jennifer-latuperisa-andresen-VVMegz6DWpM-unsplash.jpg" fill={true} /></div>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t("booking_cta_heading");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <Heading as="h2" variant="h3">{t2}</Heading>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== closest_city || $[9] !== details.startDate || $[10] !== region.title || $[11] !== regionArticle || $[12] !== t) {
    t4 = t.rich("booking_cta_body", {
      month: formatMonth(details.startDate),
      city: closest_city ?? "",
      region: `${regionArticle}${region.title}`,
      bold,
      price: priceTag
    });
    $[8] = closest_city;
    $[9] = details.startDate;
    $[10] = region.title;
    $[11] = regionArticle;
    $[12] = t;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t4) {
    t5 = <p className="mb-4 md:text-xl md:max-w-prose md:mb-6">{t4}</p>;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <li className="flex items-center"><div className="pr-2"><ContactUsButton /></div></li>;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== actions || $[18] !== isStartDateInPast || $[19] !== t) {
    t7 = <ul className="flex items-center space-x-2">{t6}<li>{isStartDateInPast ? <TooltipTrigger><Focusable><span><Button size="large" disabled={true}>{t("book_trip")}</Button></span></Focusable><Tooltip>{t("dates_past")}</Tooltip></TooltipTrigger> : <BookButton href={actions.book} mode="primary" size="large">{t("book_trip")}</BookButton>}</li></ul>;
    $[17] = actions;
    $[18] = isStartDateInPast;
    $[19] = t;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== t3 || $[22] !== t5 || $[23] !== t7) {
    t8 = <div className="relative flex flex-col items-center h-full px-4 pt-32 pb-24 text-center text-white bg-black bg-opacity-60">{t3}{t5}{t7}</div>;
    $[21] = t3;
    $[22] = t5;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== t1 || $[26] !== t8) {
    t9 = <div className="relative hidden h-auto mt-4 md:block md:rounded-xl md:overflow-hidden">{t1}{t8}</div>;
    $[25] = t1;
    $[26] = t8;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  return t9;
}